import { ArrowRight, MessageCircle } from "lucide-react";
import { Reveal } from "../components/ui-bits";
import { useApp } from "../context/AppContext";
import { waLink } from "../lib/api";

export default function FinalCTA() {
  const { config, openBooking } = useApp();
  return (
    <section className="relative py-20 lg:py-24" data-testid="final-cta-section">
      <div className="container-x">
        <Reveal>
          <div
            className="relative overflow-hidden rounded-[2rem] border border-carza/30 px-8 py-14 text-center sm:px-12"
            style={{ background: "radial-gradient(120% 160% at 50% 0%, rgba(124,77,255,0.28) 0%, rgba(26,14,51,1) 60%)" }}
          >
            <div className="dot-grid pointer-events-none absolute inset-0 opacity-60" />
            <div className="relative">
              <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-carza-lite">{config.brand.brand_tagline}</p>
              <h2 className="mx-auto mt-4 max-w-2xl font-display text-3xl font-bold tracking-tight text-paper sm:text-5xl">
                Your car, cared for. Your weekend, back.
              </h2>
              <p className="mx-auto mt-4 max-w-md text-sm text-mist sm:text-base">Booking takes under 60 seconds. Your CARZA partner handles the rest.</p>
              <div className="mt-9 flex flex-wrap items-center justify-center gap-4">
                <button onClick={() => openBooking()} className="btn btn-primary px-8 py-4" data-testid="final-cta-book-btn">
                  Book a Car Care <ArrowRight size={16} />
                </button>
                <a href={waLink(config.brand.whatsapp)} target="_blank" rel="noopener noreferrer" className="btn btn-outline px-8 py-4" data-testid="final-cta-whatsapp-btn">
                  <MessageCircle size={16} className="text-carza-lite" /> WhatsApp Us
                </a>
              </div>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
